var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCooliconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00005 5.78469L9.50755 1.27719L8.4478 0.215942L5.00005 3.66594L1.55305 0.215942L0.492554 1.27644L5.00005 5.78469Z",
    fill: "var(--primary-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooliconDown);
export default __webpack_public_path__ + "static/media/coolicon_down.2efb53dc8c08627f468c9187918b62ee.svg";
export { ForwardRef as ReactComponent };